import React from 'react';

const MenuStrip = () => <></>;

export default MenuStrip;
